export default __webpack_public_path__ + "ee1d2ccfaae1e80afd3e40c4d9b7c1aa.png";